import { VStack, Heading, Button, Text, InputGroup, InputRightElement, HStack, FormControl, Switch, Flex } from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TextField from '../TextField';
import ChangeTitle from '../ChangeTitle';
import { ViewIcon, ViewOffIcon, WarningIcon } from '@chakra-ui/icons';
import NoUserHeader from '../AreaLivre/NoUserHeader';
import { Progress } from '@chakra-ui/react';

const DadosBasicos = () => {
  ChangeTitle('Cadastro');
  const [show, setShow] = React.useState(false);
  const [rule, setRule] = React.useState(/[0-9a-zA-Z!?$*&@#-]{8,}$/);
  const [visibility, setVisibility] = React.useState('');
  const handleClick = () => setShow(!show);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [progress, setProgress] = useState(0);
  const [barColor, setBarColor] = useState('red');
  const [strengthText, setStrengthText] = useState('');

  const passwordStrength = (string) => {
    let strength = 0;

    if (/[A-Z]/.test(string)) {
      strength += 20;
    }

    if (/[a-z]/.test(string)) {
      strength += 20;
    }

    if (/[0-9]/.test(string)) {
      strength += 20;
    }

    if (/[!?$*&@#-]/.test(string)) {
      strength += 20;
    }

    if (/[0-9a-zA-Z!?$*&@#-]{8,}$/.test(string)) {
      strength += 20;
    }
    setProgress(strength);
    if (strength === 100) {
      setBarColor('green');
      setStrengthText('Senha Forte');
    }
    if (strength <= 20 && strength >= 0) {
      setBarColor('red');
      setStrengthText('Senha Fraca');
    }
    if (strength <= 40 && strength > 20) {
      setBarColor('orange');
      setStrengthText('Senha Média');
    }
    if (strength < 100 && strength > 40) {
      setBarColor('blue');
      setStrengthText('Senha Razoavel');
    }
  };
  return (
    <>
      <NoUserHeader />
      <Formik
        initialValues={{ senha: '', senha2: '' }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object({
          senha: Yup.string().trim().required('Senha Obrigatória!').matches(rule, 'Senha fora de padrão'),
          senha2: Yup.string()
            .required('Confirmação da senha é obrigatória')
            .test('pass-match', 'Senhas precisam ser iguais', function (value) {
              return this.parent.senha === value;
            }),
        })}
        onSubmit={(values, actions) => {
          const vals = { ...values };
          navigate('/cadastro/endereco', {
            state: {
              ...state,
              senha: vals.senha,
            },
          });
        }}
      >
        {({ values, errors }) => (
          <VStack as={Form} w={{ base: '90%', md: '500px' }} m="auto" justify="top" marginTop="5%" marginBottom="5%" spacing="1rem" align="start">
            <Heading fontSize="1em">Escolha uma senha segura de no mínimo 8 caracteres para o seu acesso.</Heading>
            <InputGroup size="md" id="senha">
              <TextField
                pr="4.5rem"
                name="senha"
                placeholder="Senha"
                type={show ? 'text' : 'password'}
                onKeyUp={(e) => {
                  e.preventDefault();
                  const filteredValue = e.target.value.replace(/[^0-9a-zA-Z!?$*&@#-]/g, '');
                  e.target.value = filteredValue;
                  values.senha = filteredValue;
                  passwordStrength(filteredValue);
                }}
              />
              <InputRightElement width="4rem" pt="1rem" size="md">
                <Button h="1.75rem" size="sm" onClick={handleClick} leftIcon={show ? <ViewIcon /> : <ViewOffIcon />}></Button>
              </InputRightElement>
            </InputGroup>
            <InputGroup size="md" id="senha2" pb="10%">
              <TextField pr="4.5rem" name="senha2" placeholder="Repita a senha" type={show ? 'text' : 'password'} />
              <InputRightElement width="4rem" pt="1rem" size="md">
                <Button h="1.75rem" size="sm" onClick={handleClick} leftIcon={show ? <ViewIcon /> : <ViewOffIcon />}></Button>
              </InputRightElement>
            </InputGroup>
            <Progress w="100%" value={progress} colorScheme={barColor} borderRadius="15px" />
            <Text color={barColor}>{strengthText ? strengthText + '!' : ''}</Text>

            <Button colorScheme="teal" w="100%" type="submit">
              Avançar
            </Button>
          </VStack>
        )}
      </Formik>
    </>
  );
};

export default DadosBasicos;
